import { render, staticRenderFns } from "./TitleContent.vue?vue&type=template&id=ca543402&"
import script from "./TitleContent.vue?vue&type=script&lang=js&"
export * from "./TitleContent.vue?vue&type=script&lang=js&"
import style0 from "./TitleContent.vue?vue&type=style&index=0&id=ca543402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports